import React, { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
const DynamicInput = (props) => {

    const { fieldArr, handleChange, isViewMode } = props;

    const [formFields, setFormFields] = useState( fieldArr.length > 0 ? fieldArr : [{ field: '', value: '' }] );

    useEffect(() => {
        if (fieldArr.length > 0) setFormFields(fieldArr);
    }, [fieldArr]);

    const handleFormChange = (event, index) => {

        let data = [...formFields];
        data[index][event.target.name] = event.target.value;
        setFormFields(data);
        handleChange(data);

    };

    const addFields = () => {
        setFormFields( [...formFields, { field: '', value: '' } ]);
    };

    const removeFields = (index) => {
        setFormFields((prevFields) => prevFields.filter((_, i) => i !== index));
    };

    const handleKeyChange = (event, field, parentIndex, index, oldKey) => {
        const newKey = event.target.value;

        // Create a copy of formFields
        const updatedFormFields = [...formFields];

        // Check if the parent and value array exist and the index is valid before updating
        if (
            updatedFormFields[parentIndex] &&
            updatedFormFields[parentIndex].value &&
            updatedFormFields[parentIndex].value[index]
        ) {
            const parentValue = updatedFormFields[parentIndex].value[index];

            // If the oldKey exists in the parentValue and newKey is different, update the key
            if (parentValue && parentValue.hasOwnProperty(oldKey) && newKey !== oldKey) {
                parentValue[newKey] = parentValue[oldKey]; // Update the key with the value
                delete parentValue[oldKey]; // Delete the old key
            }
        }

        // Update the form state with the modified formFields
        setFormFields(updatedFormFields);
        handleChange(updatedFormFields); // Propagate the updated state to the parent component
    };

    return (
        <>
            {formFields.map((form, index) => {
                return (
                    <div className="grid my-2" key={index}>

                        <div className="col-4">
                            {/* <label>Key</label> */}
                            <InputText name="field" onChange={(event) => handleFormChange(event, index) } value={form.field} placeholder="Field" className="mr-2" disabled={isViewMode} />
                        </div>
                        

                        {typeof form.value !== 'object' &&
                            
                            <div className={ isViewMode ? "col-8" : "col-6" }>
                                {/* <label>Value</label> */}
                                <InputText  name="value" 
                                    onChange={(event) => handleFormChange(event, index)} 
                                    value={typeof form.value === 'object' ? JSON.stringify(form.value) : form.value} 
                                    placeholder='Value' className="mr-2" disabled={isViewMode}  />
                            </div>
                            
                        }

                        {Array.isArray(form.value) && form.value.length > 0 && (
                            <>
                                <div className={isViewMode ? "col-8" : "col-6"}>
                                    {/* <label>Value</label> */}
                                    {form.value.map((item, childIndex) => (
                                        <div key={childIndex}>
                                            {Object.entries(item).map(([key, val], i) => (
                                                <div key={i} className="grid mb-2 mt-0">
                                                    {/* Key Input */}
                                                    <div className="col-6 mb-2">
                                                        {/* <label>Key</label> */}
                                                        <InputText id={`key-${key}-${childIndex}`} name={`key-${key}-${childIndex}`} value={key}
                                                            onChange={(event) => handleKeyChange(event, form.field, index, childIndex, key)}
                                                            disabled={isViewMode} />
                                                    </div>
                                                    {/* Value Input */}
                                                    <div className="col-6 mb-2">
                                                        {/* <label>Value</label> */}
                                                        <InputText id={`value-${key}-${childIndex}`} name={`value-${key}-${childIndex}`} value={val}
                                                            onChange={(event) => handleKeyChange(event, form.field, index, childIndex, key)}
                                                            disabled={isViewMode} />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}
                        
                       { !isViewMode && 
                            <div className="col-1">
                                <div className="flex gap-10">
                                    {formFields.length - 1 === index && (
                                        <Button icon="pi pi-plus" rounded outlined className="tp"
                                            aria-label="Add" onClick={addFields} type="button" data-pr-tooltip="Add" size="small"
                                        />
                                    )}

                                    <Button icon="pi pi-times" rounded outlined severity="danger" className="tp" aria-label="Remove"
                                        onClick={() => removeFields(index)}  type="button" data-pr-tooltip="Delete" size="small"
                                    />
                                </div>
                            </div>
                        }
                    </div>
                );
            })}
        </>
    );
};

export default DynamicInput;
